import { render, staticRenderFns } from "./gzjk.vue?vue&type=template&id=280c54fb&scoped=true"
import script from "./gzjk.vue?vue&type=script&lang=js"
export * from "./gzjk.vue?vue&type=script&lang=js"
import style0 from "./gzjk.vue?vue&type=style&index=0&id=280c54fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c54fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280c54fb')) {
      api.createRecord('280c54fb', component.options)
    } else {
      api.reload('280c54fb', component.options)
    }
    module.hot.accept("./gzjk.vue?vue&type=template&id=280c54fb&scoped=true", function () {
      api.rerender('280c54fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/tab4/gzjk.vue"
export default component.exports